import { object, string, unknown } from "zod";

export const getNetSuiteOrderMappingTestInput = {
  name: "getNetSuiteOrderMappingTestInput" as const,
  input: object({ orderNumber: string().trim().min(1).max(128) }),
  output: object({ input: unknown() }),
};
